import {getRawGrpcResponseErrorStatus} from '@aboutyou/data-fetcher';
import {Log} from '@aboutyou/mlm';
import {useUser} from '@aboutyou/user';
import {useCallback} from 'react';
import {
  InsufficientUserDataError,
  useIsCheckoutSessionValid,
} from '../../Checkout/useIsCheckoutSessionValid';

export function useIsAuthenticated(): {
  isAuthenticated: boolean;
  isAuthenticatedCallback: ({
    includeCheckoutSession,
  }: {
    includeCheckoutSession: boolean;
  }) => Promise<boolean>;
  isUserDataLoading: boolean;
} {
  const {data: user, isLoading: isUserDataLoading} = useUser();

  // eslint-disable-next-line todo-plz/ticket-ref
  // TODO: make sure user types can work with new situations => token is here but isLoggedIn is false
  const isLoggedIn = Boolean(user && 'token' in user && user.token);
  const isCheckoutSessionValidCallback = useIsCheckoutSessionValid();

  return {
    isAuthenticated: isLoggedIn,
    isAuthenticatedCallback: useCallback(
      async ({includeCheckoutSession}) => {
        if (!isLoggedIn) {
          return false;
        }

        let checkoutCheck = true;
        if (includeCheckoutSession) {
          try {
            await isCheckoutSessionValidCallback();
            Log.compare({
              actionName: 'SessionValidation',
              success: true,
              attributes: {
                statusText: 'OK',
              },
            });
          } catch (error) {
            const insufficientData = error instanceof InsufficientUserDataError;
            const errorCode = getRawGrpcResponseErrorStatus(error);

            Log.compare({
              actionName: 'SessionValidation',
              success: false,
              attributes: {
                errorReason: insufficientData
                  ? 'InsufficientUserDataError'
                  : error.message ?? 'request error',
                errorCode,
              },
            });
            checkoutCheck = false;
          }
        }

        return checkoutCheck;
      },
      [isCheckoutSessionValidCallback, isLoggedIn],
    ),
    isUserDataLoading: isUserDataLoading ?? true,
  };
}
